module.exports = __webpack_public_path__ + "static/img/service-04.6e7a9ebd.png";